import React, { useRef, useEffect, memo } from "react";
import { AiOutlineDoubleLeft, AiOutlineDoubleRight } from "react-icons/ai";
import { Swiper, SwiperSlide } from "swiper/react";
import { useQuery } from "react-query";
import { Autoplay } from "swiper";
import { useNavigate } from "react-router-dom";

import api from "api";
import "swiper/css";
import "./Masterclass.css";
import useSendEvent from "hooks/useSendEvent";

const RecordedMc = () => {
  const navigate = useNavigate();
  const swiperRef = useRef();
  const containerRef = useRef();
  const { sendEvent } = useSendEvent();

  const { data } = useQuery({
    queryKey: ["recent-masterclass"],
    queryFn: api.masterclass.recent,
  });

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setTimeout(() => {
              if (swiperRef.current) {
                if (swiperRef.current.autoplay) {
                  swiperRef.current.autoplay.start();
                } else {
                  console.error("Autoplay is not defined on swiperRef.current");
                }
              } else {
                console.error("swiperRef.current is not defined");
              }
            }, 2000);
          } else {
            if (swiperRef.current) {
              if (swiperRef.current.autoplay) {
                swiperRef.current.autoplay.stop();
              } else {
                console.error("Autoplay is not defined on swiperRef.current");
              }
            } else {
              console.error("swiperRef.current is not defined");
            }
          }
        });
      },
      { threshold: 0.5 }
    );

    if (containerRef.current) {
      observer.observe(containerRef.current);
    }

    return () => {
      if (containerRef.current) {
        observer.unobserve(containerRef.current);
      }
    };
  }, []);

  const NavigateDetailsPage = (classes) => {
    sendEvent("Watch Free Masterclass", "home", classes?.title);
    navigate(`/masterclass-recorded/${classes.id}`);
  };

  return (
    <>
      {data?.length !== 0 && (
        <section ref={containerRef} className="pt-[30px] pb-[30px]">
          <div className="max-w-7xl mx-auto">
            <div className="mx-5 lg:mx-10 grid grid-cols-12 gap-5 rounded-xl py-10 px-2 sm:px-5">
              <div className="col-span-12 w-full flex flex-col justify-end">
                <h2 className="text-[30px] md:text-[40px] lg:text-5xl text-white pb-5 text-center">
                  Watch Free Masterclass
                </h2>
                <div className="hidden lg:flex items-end justify-end">
                  <div className="flex items-center gap-2 custom-pagination pr-10">
                    <button
                      className="text-white border-2 border-white rounded-lg p-1 cstm-swiper-button-prev"
                      onClick={() => swiperRef.current?.slidePrev()}
                    >
                      <AiOutlineDoubleLeft />
                    </button>
                    <button
                      className="text-white border-2 border-white rounded-lg p-1 cstm-swiper-button-next"
                      onClick={() => swiperRef.current?.slideNext()}
                    >
                      <AiOutlineDoubleRight />
                    </button>
                  </div>
                </div>
              </div>
              <div className="col-span-12">
                <Swiper
                  slidesPerView={1}
                  spaceBetween={30}
                  onBeforeInit={(swiper) => {
                    swiperRef.current = swiper;
                  }}
                  autoplay={{
                    delay: 2000,
                    disableOnInteraction: false,
                    pauseOnMouseEnter: true,
                  }}
                  centeredSlides={
                    data?.length === 1 || data?.length === 2 ? true : false
                  }
                  className="mySwiper h-auto"
                  modules={[Autoplay]}
                  breakpoints={{
                    768: {
                      slidesPerView: 2,
                      spaceBetween: 30,
                    },
                    1024: {
                      slidesPerView: 3,
                      spaceBetween: 30,
                    },
                  }}
                >
                  {data?.map((classes, index) => (
                    <SwiperSlide
                      className={`rounded-xl !h-auto`}
                      key={index}
                      style={{ backgroundColor: "#e0e8fe", height: "unset" }}
                    >
                      <div
                        onClick={() => NavigateDetailsPage(classes)}
                        className="cursor-pointer h-full m-2 flex flex-col justify-between items-start pt-2 px-3 pb-6"
                        key={index}
                      >
                        <div className="w-full">
                          <img
                            src={classes?.thumbnail}
                            alt="thumbnail"
                            className="rounded-lg my-3 w-full h-[150px] object-cover"
                            loading="lazy"
                          />

                          <h2 className="text-base font-semibold">
                            {classes?.title}
                          </h2>
                        </div>

                        <div>
                          <button className="border-2 border-solid border-blue-800 px-3 py-1 rounded hover:bg-white hover:text-black">
                            Watch Now
                          </button>
                        </div>
                      </div>
                    </SwiperSlide>
                  ))}
                </Swiper>
              </div>
              <div className="flex lg:hidden col-span-12 justify-center">
                <div className="flex items-center gap-2 custom-pagination">
                  <button
                    className="text-white border-2 border-white rounded-lg p-1 cstm-swiper-button-prev"
                    onClick={() => swiperRef.current?.slidePrev()}
                  >
                    <AiOutlineDoubleLeft />
                  </button>
                  <button
                    className="text-white border-2 border-white rounded-lg p-1 cstm-swiper-button-next"
                    onClick={() => swiperRef.current?.slideNext()}
                  >
                    <AiOutlineDoubleRight />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </section>
      )}
    </>
  );
};

export default memo(RecordedMc);
